import React from 'react';
import propTypes from 'prop-types';

import { Stack, Typography } from '@metarouter-private/mr-mui';

import CopyToClipboard from 'app/components/CopyToClipboard';

const TRUNCATE_LENGTH = 12;

export default function IntegrationId({ integrationId }) {
  const truncatedId = `...${integrationId.slice(-TRUNCATE_LENGTH)}`;

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography variant="body2" title={integrationId}>
        {truncatedId}
      </Typography>
      <CopyToClipboard text={integrationId} />
    </Stack>
  );
}

IntegrationId.propTypes = {
  integrationId: propTypes.string.isRequired,
};
